<script>
import AppTable from '@/components/shared/Table.vue';
import RichTextBlock from '@/components/shared/RichTextBlock.vue';
import Property from './Property.vue';

export default {
  components: {
    AppTable,
    Property,
    RichTextBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="sub-section">
    <h4 v-if="data.heading">{{ data.heading }}</h4>

    <div v-if="data.text">
      <RichTextBlock :data="data.text" />
    </div>

    <div v-if="data.properties" class="properties">
      <Property v-for="prop in data.properties" :key="prop.sys.id" :data="prop.fields" />
    </div>

    <div v-if="data.table" class="table">
      <AppTable :content="data.table.fields" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sub-section {
  padding-bottom: $space-8;

  @include tablet-large {
    padding-bottom: $space-24;
  }

  h4 {
    margin-top: 0;
  }

  .properties,
  .table {
    margin-bottom: $space-16;
  }

  :deep(.note) {
    margin: $space-24 0;
  }
}
</style>
